import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/Zoom out.svg?react
const SvgZoomOut = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M21 21L16.65 16.65M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/ZoomOutIcon.tsx
function ZoomOutIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgZoomOut,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { ZoomOutIcon as t };
//# sourceMappingURL=ZoomOutIcon-D9I8mDKY.js.map